import { TransformNode } from "@babylonjs/core";
import { IsPhysicalDisplay, TileNavigationState, } from "core/tiles";
import { IsSize, Size2 } from "core/geometry";
import { TileWithElevation } from "./map.tile";
import { Map3dLayerView } from "./map.layer.view";
export class TextureLayerView extends Map3dLayerView {
    constructor(map, layer, display, source) {
        super(map, layer, display, source);
        this._cartesianCenterCache = null;
        this.factory.withType(TileWithElevation);
        const gridSize = map.elevationOptions?.gridSize;
        if (IsSize(gridSize)) {
            this._cachedSize = gridSize;
        }
        else {
            const d = gridSize;
            this._cachedSize = new Size2(d, d);
        }
        const scene = this._map.root.getScene();
        this._tilesRoot = this._buildRoot(scene);
    }
    get grid() {
        return this._map.grid;
    }
    get material() {
        return this._map.grid.material;
    }
    get name() {
        return this._tilesRoot.name;
    }
    get tilesRoot() {
        return this._tilesRoot;
    }
    dispose() {
        super.dispose();
    }
    get isReady() {
        return this._tilesRoot !== null && this._tilesRoot !== undefined;
    }
    _buildRoot(scene) {
        return new TransformNode(this._buildRootName(), scene);
    }
    _onTileAdded(tile) {
        const m = this._buildInstance(tile);
        if (m) {
            m.parent = this._tilesRoot;
            m.scaling.x = m.scaling.y = this.metrics.tileSize;
            m.scaling.z = 1.0;
            tile.surface = m;
            tile.gridSize = this._cachedSize;
            if (!tile.content) {
                m.setEnabled(false);
            }
            const center = this._getCenter(true);
            if (center) {
                this._setTilePosition(tile, center);
            }
        }
    }
    _onTileRemoved(tile) {
        if (tile.surface) {
            tile.surface.dispose();
            tile.surface = null;
        }
    }
    _onTileUpdated(tile) {
        if (tile.surface) {
            tile.surface.setEnabled(tile.content !== null && tile.content !== undefined);
        }
    }
    _buildInstance(tile) {
        const instance = this._map.grid.createInstance(this._buildInstanceName(tile));
        return instance;
    }
    _setTilePosition(tile, center) {
        if (tile?.boundingBox && tile?.surface) {
            const c = tile.boundingBox.center;
            const p = tile.surface.position;
            p.x = center.x - c.x;
            p.y = center.y - c.y;
            p.z = 0;
        }
    }
    _applyNavigation(nav) {
        if (nav) {
            this._onCenterChanged();
            this._onZoomChanged();
        }
    }
    _setScale(nav, display, layer, metrics) {
        const groundResolution = metrics.groundResolution(nav.center.lat, nav.lod);
        const x = display.dimension.width / (display.resolution.width * groundResolution);
        const y = display.dimension.height / (display.resolution.height * groundResolution);
        let z = Math.max(x, y);
        if (display.dimension.depth && display.resolution.depth) {
            z = display.dimension.depth / (display.resolution.depth * groundResolution);
        }
        this._tilesRoot.scaling.x = x * groundResolution * nav.scale;
        this._tilesRoot.scaling.y = y * groundResolution * nav.scale;
        this._tilesRoot.scaling.z = z * (this._map.elevationOptions?.exageration ?? TextureLayerView.DefaultExageration) * nav.scale;
    }
    _onNavigationChanged(oldValue, newValue) {
        if (newValue && newValue !== oldValue) {
            this._applyNavigation(newValue);
        }
    }
    _onNavigationPropertyChanged(event, state) {
        switch (event.propertyName) {
            case TileNavigationState.CENTER_PROPERTY_NAME: {
                this._cartesianCenterCache = null;
                this._onCenterChanged();
                this._onZoomChanged();
                break;
            }
            case TileNavigationState.ZOOM_PROPERTY_NAME: {
                this._onZoomChanged();
                break;
            }
        }
        super._onNavigationPropertyChanged(event, state);
    }
    _onZoomChanged() {
        if (this.isReady && IsPhysicalDisplay(this.display)) {
            this._setScale(this.navigationState, this.display, this.layer, this.metrics);
        }
    }
    _onCenterChanged() {
        if (this.isReady) {
            const tiles = this._activTiles;
            if (!tiles || !tiles.count) {
                return;
            }
            const center = this._getCenter(true);
            if (center) {
                for (const tile of tiles) {
                    this._setTilePosition(tile, center);
                }
            }
        }
    }
    _getCenter(force = false) {
        const nav = this.navigationState;
        if (nav) {
            if (force || !this._cartesianCenterCache) {
                const geo = nav.center;
                this._cartesianCenterCache = this.metrics.getLatLonToPointXY(geo.lat, geo.lon, nav.lod);
            }
            return this._cartesianCenterCache;
        }
        return undefined;
    }
    _buildRootName() {
        return `${this.layer.name}-${TextureLayerView.ROOT_SUFFIX}`;
    }
    _buildInstanceName(tile) {
        return tile.quadkey;
    }
}
TextureLayerView.DefaultExageration = 1.0;
TextureLayerView.ROOT_SUFFIX = "root";
//# sourceMappingURL=map.layer.texture.js.map